import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ReportDateRangeService } from '../../report-date-range.service';

@Component({
  selector: 'app-report-date-range',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './report-date-range.component.html',
  styleUrl: '../../report-shared.css',
})
export class ReportDateRangeComponent {
  protected dateRange = inject(ReportDateRangeService);
  showError = false;

  generate(): void {
    if (!this.dateRange.apply()) {
      this.showError = true;
      return;
    }

    this.showError = false;
  }

  onStartDateChange(value: string): void {
    this.dateRange.draftStartDate.set(value);
    this.onDraftChange();
  }

  onEndDateChange(value: string): void {
    this.dateRange.draftEndDate.set(value);
    this.onDraftChange();
  }

  onDraftChange(): void {
    if (this.dateRange.isDraftValid()) {
      this.showError = false;
    }
  }
}
